import * as React from "react";
import { Link } from "gatsby"

export const Layout = ({ children }) => {
    const rawHTML =
        (
            <div className="content">
                <div className="grid">
                    {children}
                    <div className="grid-child footer">
                        <h2 id="w-node-bfeb74a4b3b5-74a4b3b4" className="footer-heading">ELLIOT YOUNG&#x27;S INTERNSHIP BLOG.</h2>
                        <div id="w-node-bfeb74a4b3b7-74a4b3b4" className="form-block w-form">
                            <form
                                name="high-five"
                                method="post"
                                data-netlify="true"
                                data-netlify-honeypot="bot-field"
                            >
                                <input type="hidden" name="form-name" value="contact" />
                                <p hidden>
                                    <label>
                                        Don’t fill this out: <input name="bot-field" />
                                    </label>
                                </p>
                                <h4>VIRTUAL HIGH-5? </h4>
                                <input type="text" name="message" className="text-field w-input" placeholder="Message" />
                                <div className="form-box">
                                    <input type="email" name='email' className="text-field w-input" placeholder="Email" />
                                    <button className="button" type="submit">Send</button>
                                </div>
                            </form>
                        </div>
                        <div id="w-node-bfeb74a4b3c6-74a4b3b4" className="spacer"></div>
                        <div id="w-node-bfeb74a4b3c7-74a4b3b4" className="div-block">
                            <div className="footer-column">
                                <h4>MENU</h4>
                                <Link to="/" className="link">Home</Link>
                                <Link to="/timeline" className="link">Timeline</Link>
                                <Link to="/topics" className="link" >Topics</Link>
                                <Link to="/tools" className="link" >Tools</Link>
                            </div>
                            <div className="footer-column">
                                <h4>CONTACT</h4>
                                <a href="mailto:elliot.young@my.wheaton.edu" className="link">Email</a>
                                <a href="https://www.linkedin.com/in/efonov/" className="link">LinkedIn</a>
                                <a href="https://github.com/elliot-wheaton" className="link">GitHub</a>
                            </div>
                        </div>
                    </div>
                    <div className="navigation">
                        <Link className="link-block" to="/" activeClassName="active">
                            <h4 className="vertical-text" >HOME</h4>
                        </Link>
                        <Link className="link-block" to="/timeline" activeClassName="active">
                            <h4 className="vertical-text">TIMELINE</h4>
                        </Link>
                        <Link className="link-block" to="/topics" activeClassName="active">
                            <h4 className="vertical-text">TOPICS</h4>
                        </Link>
                        <Link className="link-block" to="/tools" activeClassName="active">
                            <h4 className="vertical-text">TOOLS</h4>
                        </Link>
                    </div>
                </div>
            </div>
        )
    return rawHTML;
}